import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from "./resources";

i18n.use(initReactI18next).init({
  fallbackLng: 'us',
  lng: 'us',
  debug: true,
  resources,
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['us','de', 'ch', 'at', 'hu', 'pl'];

export default i18n;